"use client";

import { Card } from "@mui/material";
import Grid from "@mui/material/Grid2";

import MDAvatar from "@/components/atoms/MDAvatar";
import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { getAvatarLetters } from "@/helpers/profile-helpers";
import useUserData from "@/hooks/data/use-user-data";
import IUser from "@/interfaces/user.interface";

type Props = {
  user: IUser;
  userKeyText: string;
};
function ProfileSummaryCard({ user, userKeyText }: Props) {
  const { name = "", userKey } = useUserData({ user });

  return (
    <Card>
      <MDBox p={2}>
        <Grid container spacing={3} alignItems="center">
          <Grid>
            <MDAvatar bgColor="dark" size="xl" shadow="sm">
              <MDTypography variant="h5" color="white" fontWeight="medium">
                {getAvatarLetters(name)}
              </MDTypography>
            </MDAvatar>
          </Grid>
          <Grid>
            <MDBox height="100%" mt={0.5} lineHeight={1}>
              <MDTypography variant="h5" fontWeight="medium">
                {name}
              </MDTypography>
              <MDTypography variant="button" color="text">
                {userKeyText}: {userKey}
              </MDTypography>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}

export default ProfileSummaryCard;
